(function() { module.exports = window["novablocks"]["blob/frontend"]; }());